import { Injectable } from "@angular/core";
import { DestroyRef, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { NGXLogger, NgxLoggerLevel } from "ngx-logger";
import { Observable } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { initStaticLoggerReference } from "./logger.reference";
import { LoggingState } from "./state/logging-state/logging.reducer";
import { selectLoggingState } from "./state/logging-state/logging.selectors";

@Injectable({ providedIn: "root" })
export class LoggerConfigurationService {
  private readonly destroyRef = inject(DestroyRef);
  private initialized = false;

  loggingState$: Observable<LoggingState> =
    this.store.select(selectLoggingState);

  functionReference = initStaticLoggerReference; // For spying in the test

  constructor(
    private store: Store<any>,
    private loggerInstance: NGXLogger,
  ) {}

  init() {
    this.functionReference(this.loggerInstance);

    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.loggingState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((ls) => {
        if (!ls || ls.level === undefined || ls.level === null) {
          return;
        }

        this.updateLogLevel(ls.level);
      });
  }

  updateLogLevel(level: NgxLoggerLevel) {
    const currentLoggerConfig = this.loggerInstance.getConfigSnapshot();
    this.loggerInstance.updateConfig(
      Object.assign({}, currentLoggerConfig, { level }),
    );
    this.loggerInstance.info(`LOGGER: level`, level);
  }
}
